var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayJavaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 100,
    viewBox: "0 0 74 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8653 77.3043C23.8653 77.3043 20.0509 79.5225 26.5801 80.2731C34.4902 81.1754 38.5327 81.0462 47.2497 79.3962C47.2497 79.3962 49.5416 80.8332 52.7419 82.078C33.2012 90.4529 8.51678 81.5928 23.8653 77.3043ZM21.4775 66.3754C21.4775 66.3754 17.1991 69.5425 23.7333 70.2182C32.183 71.0899 38.8558 71.1613 50.4026 68.9379C50.4026 68.9379 51.9997 70.5569 54.511 71.4425C30.8847 78.3511 4.56938 71.9873 21.4775 66.3754Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6075 47.8367C46.4225 53.3801 40.3425 58.3685 40.3425 58.3685C40.3425 58.3685 52.5682 52.0572 46.9535 44.1538C41.7095 36.7838 37.6879 33.1214 59.4587 20.4954C59.4587 20.4954 25.2858 29.0303 41.6075 47.8367Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.452 85.3879C67.452 85.3879 70.2749 87.7136 64.3431 89.513C53.0639 92.9301 17.3974 93.9618 7.48931 89.6491C3.92775 88.1 10.6069 85.9497 12.7078 85.4983C14.8989 85.0231 16.1512 85.1118 16.1512 85.1118C12.1902 82.3214 -9.45086 90.5907 5.15868 92.9587C45.0006 99.4199 77.7864 90.0494 67.452 85.3879ZM25.6994 55.052C25.6994 55.052 7.55752 59.3613 19.2752 60.9257C24.2225 61.5881 34.0853 61.4384 43.2723 60.6685C50.7803 60.0355 58.3194 58.6887 58.3194 58.6887C58.3194 58.6887 55.672 59.8225 53.7566 61.1303C35.3335 65.9757 -0.25664 63.7217 9.98931 58.7653C18.6543 54.5769 25.6994 55.052 25.6994 55.052ZM58.2445 73.2433C76.9728 63.5116 68.3136 54.1595 62.2697 55.4197C60.7882 55.7277 60.1278 55.9948 60.1278 55.9948C60.1278 55.9948 60.6777 55.1335 61.728 54.7607C73.6847 50.5569 82.8803 67.1587 57.8682 73.7338C57.8682 73.7341 58.1581 73.4751 58.2445 73.2433Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 0.107226C46.9535 0.107226 57.3254 10.4829 37.1162 26.437C20.9107 39.2353 33.4208 46.5324 37.1095 54.8696C27.65 46.335 20.7078 38.8217 25.3653 31.8292C32.2009 21.5642 51.1382 16.5879 46.9535 0.107226Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5399 99.6142C45.5165 100.765 73.1214 98.9757 73.7752 90.4697C73.7752 90.4697 72.5185 93.6945 58.9185 96.2552C43.5751 99.1425 24.6514 98.8055 13.4275 96.9549C13.4277 96.9549 15.7249 98.8566 27.5399 99.6142Z",
    fill: "#5382A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayJavaLogo);
export default __webpack_public_path__ + "static/media/play-java-logo.4bd84b8d0c6617899ba21b01ac3ad5ff.svg";
export { ForwardRef as ReactComponent };